export default __webpack_public_path__ + "static/media/Transbank.143d785c.svg";